"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
function PricingTierCard({ pricingTier }) {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: pricingTier && ((0, jsx_runtime_1.jsxs)("div", { className: "summary__card card", children: [(0, jsx_runtime_1.jsx)("div", { className: "card-section title", children: "CURRENT PRICING TIER" }), (0, jsx_runtime_1.jsx)("div", { className: "card-section sub-title", children: pricingTier.notes })] })) }));
}
exports.default = (0, react_1.memo)(PricingTierCard);
